//// =====================================================
//   Local
//// =====================================================
// export const Environment = {
//     Web: 'https://localhost:4200',
//     Api: 'https://localhost:7135',
//     ertikazApi: 'https://localhost:7014',
//     financeContactPage: 'https://finance.ertikaz-tech.com/demo',
// }

//// =====================================================
//   Staging
//// =====================================================
// export const Environment = {
//     Web: 'https://staging-dispatcher.ertikaz.tech',
//     Api: 'https://staging-dispatcher-api.ertikaz.tech',
//     ertikazApi: 'https://staging-shared-api.ertikaz.tech',
//     financeContactPage: 'https://finance.ertikaz-tech.com/demo',
// }

//// =====================================================
//   Production
//// =====================================================
export const Environment = {
    Web: 'https://dispatcher.ertikaz-tech.com',
    Api: 'https://dispatcher-api.ertikaz-tech.com',
    ertikazApi: 'https://shared.ertikaz.tech',
    ertikazPublicApi: 'https://public-api.ertikaz.tech',
    financeContactPage: 'https://finance.ertikaz-tech.com/demo',
}